import React, { useContext, useEffect, useState } from 'react';
import {
  Card, Row, Col, Alert,
} from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import Flex from '../../common/Flex';
import Avatar from '../../common/Avatar';
import logo from '../../../../assets/img/icons/ciat.png';
import EmailDetailHeader from './EmailDetailHeader';
import { EmailContext } from '../../context/Context';
import EmailProvider from '../EmailProvider';
import EmailFooter from './EmailFooter';
import { convertStringToDate } from '../../../../common/funcs';
import { longFormat } from '../../../../constants/date';

function EmailDetailElement({ id }) {
  // const [marked, setMarked] = useState(true);
  const { emails } = useContext(EmailContext);
  const [emailDetails, setEmailDetails] = useState();
  const [emailIndex, setEmailIndex] = useState();

  useEffect(() => {
    const findEmail = emails.find((item) => item.id === parseInt(id, 10));
    setEmailDetails(findEmail);
    setEmailIndex(emails.indexOf(findEmail));
  }, [emails, id]);

  return (
    <>
      <EmailDetailHeader
        read={emailDetails !== undefined && emailDetails.read}
        id={emailDetails !== undefined && emailDetails.id}
      />
      {(emailDetails !== undefined) ? (
        <Card>
          <Card.Header>
            <Row>
              <Col md as={Flex}>
                <Avatar src={logo} size="2xl" />
                <div className="flex-1 ms-2">
                  <h5 className="mb-0">{emailDetails.title}</h5>
                </div>
              </Col>
              <Col
                md="auto"
                as={Flex}
                alignItems="center"
                className="ps-6 ps-md-3"
              >
                <small>{convertStringToDate(emailDetails.created).toLocaleString('uk', longFormat)}</small>
              </Col>
            </Row>
          </Card.Header>
          <Card.Body className="bg-light">
            <Row className="justify-content-center">
              <Col lg={8} xxl={6}>
                <Card className="shadow-none mb-3">
                  <Card.Body>
                    {emailDetails.description}
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Card.Body>
          <Card.Footer>
            {emailIndex > -1 && (
            <EmailFooter
              totalItems={emails.length}
              emailIndex={(emailIndex + 1)}
              canNextPage={emailIndex < (emails.length - 1)}
              canPreviousPage={emailIndex > 0}
              nextPage={
              emailIndex < (emails.length - 1) ? `/email/email-detail/${emails[emailIndex + 1].id}` : '*'
            }
              prevPage={
              emailIndex > 0 ? `/email/email-detail/${emails[emailIndex - 1].id}` : '*'
            }
            />
            )}
          </Card.Footer>
        </Card>
      ) : (
        <Alert variant="info" className="mb-0 rounded-0">
          <h5 className="alert-heading">Виникла помилка</h5>
          <hr />
          <p className="mb-0">
            Повідомлення не знайдено.
          </p>
        </Alert>
      )}
    </>
  );
}

function EmailDetail() {
  const { id } = useParams();
  return (
    <EmailProvider>
      <EmailDetailElement id={id} />
    </EmailProvider>
  );
}

EmailDetailElement.propTypes = {
  id: PropTypes.number.isRequired,
};

export default EmailDetail;
